module.exports = __webpack_public_path__ + "img/5c5d2b0.jpg";